import { EntityRepository, Repository } from "typeorm";
import { SoProduction } from "../entities/so-production.entity";

@EntityRepository(SoProduction)
export class SoProductionRepository extends Repository<SoProduction> {


}
